const scriptEl = document.currentScript;

document.addEventListener("DOMContentLoaded", () => {
  if (!scriptEl) {
    return;
  }
  const sectionId = scriptEl?.dataset?.sectionId;
  const section = document.getElementById(`shopify-section-${sectionId}`);
  if (!section) {
    return;
  }

  const list = section.querySelector(".announcement-bar__list");
  if (!list) {
    return;
  }

  const baseDelay = scriptEl.dataset.sectionSpeed;
  const scrollSpeed = 50;

  /** @type {any} */
  let flkty = null;

  function setHeightVar() {
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      section.clientHeight + "px"
    );
  }

  function applyScrollAnimation(slideEl) {
    const textElement = slideEl?.querySelector(".announcement-text-wrapper");
    if (!textElement) {
      return baseDelay;
    }

    const containerWidth = slideEl.offsetWidth;
    const textWidth = textElement.scrollWidth;
    const overflow = textWidth - containerWidth;

    if (overflow > 0) {
      const half = overflow / 2;
      // 70% of the animation is spent moving; the other 30% are reading pauses
      // baked into the keyframes (15% at the start, 15% at the end).
      const duration = overflow / scrollSpeed / 0.7;

      // The text is wider than its (centered) container, so it overflows
      // equally on both sides. Scroll it between these two bounded positions so
      // it stays inside the visible area the whole time instead of sweeping
      // off-screen. RTL: reveal the beginning (right edge) first, then the end.
      textElement.style.setProperty("--scroll-start", `${-half}px`);
      textElement.style.setProperty("--scroll-end", `${half}px`);
      textElement.style.animation = `scrollText ${duration}s linear forwards`;
      return Math.max(duration * 1000, Number(baseDelay));
    }

    return baseDelay;
  }
  function resetAllSlides(slideEl) {
    const p = slideEl?.querySelector(".announcement-text-wrapper");
    if (!p) {
      return;
    }
    p.style.animation = "none";
    p.style.transform = "translateX(0)";
    p.style.removeProperty("--scroll-start");
    p.style.removeProperty("--scroll-end");
  }
  function setDynamicAutoPlay() {
    if (!flkty) {
      return;
    }
    const delay = applyScrollAnimation(flkty.selectedElement);
    flkty.stopPlayer();
    flkty.options.autoPlay = Number(delay);
    flkty.playPlayer();
  }

  function build() {
    // @ts-ignore
    flkty = new Flickity(list, {
      cellAlign: "left",
      contain: true,
      wrapAround: true,
      rightToLeft: true,
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: false,
      draggable: true,
    });

    setDynamicAutoPlay();

    flkty.on("select", function () {
      resetAllSlides(flkty.selectedElement);
      setDynamicAutoPlay();
    });

    flkty.on("pointerUp", setDynamicAutoPlay);
    flkty.on("staticClick", setDynamicAutoPlay);

    if (flkty.slides.length <= 1) {
      section
        .querySelectorAll(".flickity-prev-button, .flickity-next-button")
        // @ts-ignore
        .forEach((btn) => (btn.style.display = "none"));
    }

    setHeightVar();
  }

  function rebuild() {
    if (flkty) {
      try {
        flkty.destroy();
      } catch (e) {
        /* noop */
      }
      flkty = null;
    }
    build();
  }
  build();
  window.addEventListener("load", rebuild);
  let lastWidth = window.innerWidth;
  let resizeTimer;
  window.addEventListener("resize", () => {
    if (window.innerWidth === lastWidth) {
      return;
    }
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(rebuild, 200);
  });

  // The custom arrows live outside the carousel, so they survive rebuilds and
  // only need to be wired up once.
  section
    .querySelector(".flickity-prev-button")
    ?.addEventListener("click", () => flkty && flkty.previous());
  section
    .querySelector(".flickity-next-button")
    ?.addEventListener("click", () => flkty && flkty.next());
});
